// idb-result.js — petit adaptateur pour récupérer la valeur d'une IDBRequest
// au moment où la transaction se termine, y compris lorsque cette valeur est
// légitimement `undefined` (clé absente).
//
// IMPORTANT : le marqueur existe DÈS la création du wrapper. Il ne faut pas
// tester la présence de la valeur avant `request.onsuccess`, car IndexedDB est
// asynchrone et le résultat n'est pas encore disponible à cet instant.
const REQUEST_VALUE = Symbol('indexeddb-request-value');

export function trackRequestValue(request) {
  const tracked = { [REQUEST_VALUE]: true, value: undefined };
  request.onsuccess = () => { tracked.value = request.result; };
  return tracked;
}

export function isTrackedRequestValue(value) {
  return Boolean(value && typeof value === 'object' && value[REQUEST_VALUE] === true);
}

export function unwrapRequestValue(value) {
  return isTrackedRequestValue(value) ? value.value : value;
}
